import type { AssistantReplySummary } from "./collapsedReplyPreview";

export function shouldShowUnreadReply({
  reply,
  replyBeforeLoading,
  completedThreadId,
  currentThreadId,
  isCollapsed,
}: {
  reply: AssistantReplySummary | null;
  replyBeforeLoading: string | null;
  completedThreadId: string | null;
  currentThreadId: string | null;
  isCollapsed: boolean;
}): boolean {
  return Boolean(
    isCollapsed &&
      completedThreadId === currentThreadId &&
      reply &&
      !reply.isError &&
      reply.key !== replyBeforeLoading
  );
}
